/**
 * Additional nav tabs for QuickSight Reports — kept separate from navTabsConfig.js.
 */
export const quicksightReportsNavTabs = [
    {
        id: "lead_source_performance",
        permission: "leadSourcePerformance",
        label: "Lead Source Performance",
        badge: null,
        href: "/quicksight-reports?_tab=lead_source_performance"
    },
    {
        id: "outreach_and_enrollment",
        permission: "outreachAndEnrollment",
        label: "Outreach and Enrollment",
        badge: null,
        href: "/quicksight-reports?_tab=outreach_and_enrollment"
    }
];
